import React from 'react';
import Wizard from './components/Wizard';
import './index.css';

function App() {
  return (
    <div className="App">
      <Wizard />
    </div>
  );
}

export default App;
